import PropTypes from 'prop-types'
import { Link } from 'react-router'
import styled, { css } from 'styled-components'

import colors from 'components/utils/colors'

import Icon from 'components/Shared/Icon/Index'

export const StyledMegaMenuRowsGroup = styled.div`
  min-width: 180px;
  display: block;
  ${props => props.isHighlighted && css`
    background-color: ${colors.secondary95};

    a {
      color: ${colors.secondary20};
      border-bottom: 1px solid ${colors.secondary80};
      &.active {
        color: #000;
      }
    }
  `}
`

const HeaderStyles = css`
  display: block;
  position: relative;
  height: 23px;
  line-height: 23px;
  padding: 0 16px;
  font-size: 10px;
  font-family: Exo;
  font-weight: 600;
  color: ${colors.secondary60} !important;
  text-transform: uppercase;
  border-bottom: 1px solid ${colors.secondary60} !important;
`

const StyledTitle = styled.div`
  ${HeaderStyles}
`

const StyledLink = styled(Link)`
  ${HeaderStyles}
  ${props => props.to && css`
    &:hover {
      cursor: pointer;
      background-color: ${colors.primary90};

      i::before {
        color: ${colors.primary35};
      }
    }
  `}
`

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 6px;
  right: 5px;
`

const MegaMenuRowsGroup = ({ title, isHighlighted, to, children }) => {
  return (
    <StyledMegaMenuRowsGroup isHighlighted={isHighlighted} data-test='megamenu-rows-group'>
      {to
        ? (
          <StyledLink to={to}>
            {title}
            <StyledIcon iconName='icon-switch-to-norm-10' />
          </StyledLink>
          )
        : <StyledTitle>{title}</StyledTitle>
      }
      {children}
    </StyledMegaMenuRowsGroup>
  )
}

MegaMenuRowsGroup.propTypes = {
  title: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool,
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  children: PropTypes.node,
}

export default MegaMenuRowsGroup
